<template>
<Modal title="编辑" v-model="visible" @on-visible-change="onVisibleChange">
  <Form ref="form" class="form" :model="formData" :rules="formRule" :label-width="80">
    <Row>
      <i-col :span="22">
        <Form-item label="名称" prop="title">
          <Input v-model="formData.title"/>
        </Form-item>
      </i-col>
      <i-col :span="22">
        <Form-item label="描述" prop="descr">
          <Input v-model="formData.descr"/>
        </Form-item>
      </i-col>
      <i-col :span="22">
        <Form-item label="分类" prop="pid" v-if="parentId != null">
          <Select v-model.number="parentId" @on-change="onPidChange">
            <Option v-for="item in parentList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </Form-item>
      </i-col>
      <i-col :span="22">
        <Form-item label="展现类型">
          <Select v-model.number="formData.itemType" placeholder="全部" clearable>
            <Option v-for="item in $constant.itemType"
                    @on-change="search" :value="item.code" :key="item.code">{{ item.text }}</Option>
          </Select>
        </Form-item>
      </i-col>
      <i-col :span="22">
        <Form-item label="状态" prop="status">
          <Select v-model.number="formData.state">
            <Option v-for="item in statusList" :value="item.code" :key="item.code">{{ item.text }}</Option>
          </Select>
        </Form-item>
      </i-col>
    </Row>
  </Form>
  <div slot="footer">
    <Button type="text" size="large" @click="visible=false">取消</Button>
    <Button type="primary" size="large" :loading="loadingEdit" @click="edit">保存</Button>
  </div>
</Modal>
</template>
<script>
  export default {
    name: 'EditItemModal',
    props: {
      itemId: Number,
      value: {
        type: Boolean,
        default: false
      },
      pid: Number,
    },
    data () {
      let $constant = this.$constant
      return {
        visible: this.value,
        formRule: {},
        parentList: [],
        searchLoading: false,
        loadingEdit: false,
        parentId: null,
        statusList: $constant.enabledStatus,
        formData: {
          title: '',
          desc: '',
          pid: '',
          itemType: '',
          state: '',
        },
      }
    },
    mounted: function () {

    },
    created: function () {

    },
    methods: {
      onVisibleChange (val) {
        let self = this
        if (!val) {
          self.$emit('on-close')
        }
      },
      onPidChange () {
        this.formData.pid = this.pid
      },
      search () {
        this.reload = new Date().getTime()
      },
      edit () {
        let self = this
        self.loadingEdit = true
        self.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingEdit = false
            return
          }
          let path = '/adminConfig/update'
          if (!this.formData.id || this.formData.id === '') {
            path = '/adminConfig/insert'
          }
          self.$http.post(path, self.formData).then(function (res) {
            if (res && res.data > 0) {
              self.visible = false
              self.$Message.success('提交成功!')
              self.search()
              self.$emit('on-edit-success')
              self.clearItem()
            }
            self.loadingEdit = false
          })
        })
      },
      clearItem () {
        let self = this
        self.formData.title = ''
        self.formData.id = ''
        self.formData.descr = ''
        self.formData.pid = ''
        self.formData.itemType = ''
        self.formData.state = ''
        self.parentId = null
      },
    },
    watch: {
      value (val) {
        let self = this
        if (val) {
          self.$http.get('/adminConfig/getParent').then(function (res) {
            self.parentList = res.data
          })
          self.visible = true
        } else {
          self.visible = false
          this.clearItem()
        }
      },
      pid (val) {
        let self = this
        if (val) {
          self.parentId = val
          self.formData.pid = val
        }
      },
      itemId (val) {
        if (val) {
          let self = this
          self.$http.get('/adminConfig/getItemById?id=' + val).then(function (res) {
            if (res.data) {
              self.formData.title = res.data.title
              self.formData.id = res.data.id
              self.formData.descr = res.data.descr
              self.formData.pid = res.data.pid
              self.formData.itemType = res.data.itemType
              self.formData.state = res.data.state
            }
            self.$emit('on-edit-clearid')
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EditItemModal.vue?09bb80d2